import React, { Component } from 'react';
import { Button, Popup } from 'semantic-ui-react'
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6
import { modules, formats } from './TextEditorToolbar';
import { Form } from 'formsy-semantic-ui-react';
import { singleLineText } from './RegexValidation';
import _ from 'lodash'

export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editable: false,
            name: props.name,
            text: props.text,
            blankTextError: false
        }
        this.reactQuillRef = null; // ReactQuill component
        this.handleChange = this.handleChange.bind(this)
    }

    editClick = () => {
        this.setState({
            editable: true,
            name: this.props.name,
            text: this.props.text,
            blankTextError: false
        })
    }
    setName = (e) => {
        this.setState({ text: e.target.value.trim(), blankTextError: false })
    }
    cancelClick = () => {
        this.setState({
            editable: false,
        })
    }

    saveClick = () => {
        if (!this.state.text) {
            this.setState({ blankTextError: true })
        } else {
            this.props.onSaveClick(this.state)
            this.setState({ editable: false, blankTextError: false })
        }
    }

    handleChange(value) {
        this.setState({ text: value, blankTextError: false })
    }

    componentWillReceiveProps(newProps) {
        if (newProps.text !== this.state.text || !this.state.editable) {
            this.setState({ text: newProps.text });
        }
        this.setState({ blankTextError: false })
    }

    render() {
        setTimeout(
            function () {
                var elements = document.querySelectorAll('.ql-editor');

                if (elements.length) {
                    elements[0].id = this.props.name
                }
            }
                .bind(this),
            200
        );

        const errorLabel = <div className="customErrorLabel" />;
        const buttons = <div className="actionBtn" style={{ margin: this.props.type === 'text' ? '-10px 0 0 0' : '' }}>
            <Button style={{ margin: "0 0 0 5px !important" }} icon="cancel" className="button-cancel" onClick={this.cancelClick} id={this.props.name + '_cancel'} />
            <Button icon="check" className="button-submit" onClick={this.saveClick} id={this.props.name + '_check'} />
        </div>;


        let checkTextareaValue = (this.props.text && this.props.text.length === 0) || this.props.text === '<p><br></p>' || this.props.text === ''
        return (
            <div className="edit-text">
                {this.state.editable || this.props.isError ?
                    this.props.type === 'text' ?
                        <div style={{ padding: '0 5px' }}>
                            <Form noValidate
                                className="formcyForm editName"
                                ref={ref => this.form = ref}
                                onValidSubmit={this.props.onSubmit}
                            >
                                <Popup
                                    mouseEnterDelay={400}
                                    inverted
                                    className="popupStyled"
                                    open={this.state.blankTextError}
                                    content={`${this.props.name} can not be empty`}
                                    position="top left"
                                    trigger={
                                        <Form.Input
                                            required
                                            name={this.props.name}
                                            id={this.props.name}
                                            label={this.props.name}
                                            icon={this.state.blankTextError ? "exclamation triangle" : ""}
                                            onChange={this.setName}
                                            value={this.state.text}
                                            validations={{ matchRegexp: singleLineText }}
                                            errorLabel={errorLabel}
                                            instantValidation
                                            autoFocus={true}
                                            validationErrors={{
                                                matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                                isDefaultRequiredValue: 'Name is required',
                                            }}
                                            className="editTextInput"
                                        />
                                    }
                                >
                                </Popup>

                                {buttons}
                            </Form>
                        </div> :
                        this.props.type === 'textarea' ?
                            <div style={{ padding: '0 5px' }}>
                                <label className="f_semiBold">{this.props.name}</label>
                                <ReactQuill
                                    value={this.state.text ? this.state.text : ""}
                                    key={this.state.name}
                                    onChange={this.handleChange}
                                    id={this.props.name}
                                    theme="snow"
                                    modules={modules}
                                    formats={formats}
                                />
                                {buttons}
                            </div>
                            : ""
                    :
                    <div className="commanLabel ">
                        <label>{this.props.name}</label>
                        <div className="commanLabelText" onClick={this.editClick}>
                            {this.props.htmlView ?
                                <div dangerouslySetInnerHTML={{ __html: checkTextareaValue ? `No ${_.lowerCase(this.props.name)} added` : this.props.text }} /> :
                                this.props.text}
                        </div>
                    </div>}
            </div>
        );
    }
}
